import { render, staticRenderFns } from "./IpBlockers.vue?vue&type=template&id=54e0dd05&"
import script from "./IpBlockers.vue?vue&type=script&lang=ts&"
export * from "./IpBlockers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports